import { render, staticRenderFns } from "./CloneConvo.vue?vue&type=template&id=14e72508&scoped=true&"
import script from "./CloneConvo.vue?vue&type=script&lang=js&"
export * from "./CloneConvo.vue?vue&type=script&lang=js&"
import style0 from "./CloneConvo.vue?vue&type=style&index=0&id=14e72508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e72508",
  null
  
)

export default component.exports